import React,{useState} from 'react';
import { Button } from "@components/ui/button";

interface MessageComponentProps {
  message: string;
  onButton1Click: () => void;
  onButton2Click: () => void;
}

const Notify: React.FC<MessageComponentProps> = ({
  message,
  onButton1Click,
  onButton2Click,
}) => {


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-md text-center">
        <p className="text-[17px]  mb-4">{message}</p>

        <div  className="flex  flex-row justify-center items-center space-x-4">
          <Button
className="w-full mt-5 bg-[#1CB5AF]"            onClick={onButton1Click}
          >
            Okay
          </Button>

          <Button
className="w-full mt-5 bg-[#1CB5AF]"            onClick={onButton2Click}
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Notify;
